(() => {
  const HIDDEN = 'sp-hidden';
  const MIN_PREFIX = 3;

  function tokenise(value) {
    return String(value || '')
      .toLowerCase()
      .split(/[^\p{L}\p{N}+]+/u)
      .filter(Boolean);
  }

  function buildIndex(root) {
    return [...root.querySelectorAll('[data-doc-item]')].map((el) => ({
      el,
      overflow: el.hasAttribute('data-overflow'),
      tokens: tokenise(el.dataset.search),
    }));
  }

  function matches(entry, queryTokens) {
    return queryTokens.every((needle) =>
      entry.tokens.some(
        (token) =>
          token.startsWith(needle) || (token.length >= MIN_PREFIX && needle.startsWith(token))
      )
    );
  }

  function bind(host) {
    const input = host.querySelector('[data-document-search-input]');
    if (!input) return;

    const status = host.querySelector('[data-document-search-status]');
    const template = host.dataset.resultsTemplate || '';
    const scope = document;
    let index = buildIndex(scope);
    let timer = 0;

    function apply(query) {
      const queryTokens = tokenise(query);
      const searching = queryTokens.length > 0;
      let hits = 0;

      for (const entry of index) {
        const visible = searching ? matches(entry, queryTokens) : !entry.overflow;
        if (searching && visible) hits += 1;
        entry.el.classList.toggle(HIDDEN, !visible);
      }

      for (const group of scope.querySelectorAll('[data-search-group]')) {
        const hideOnQuery = group.hasAttribute('data-search-group-hide-on-query');
        const hasVisible = !!group.querySelector(`[data-doc-item]:not(.${HIDDEN})`);
        const show = searching ? hasVisible && !hideOnQuery : true;
        group.classList.toggle(HIDDEN, !show);
      }

      const chrome = scope.querySelectorAll(
        '[data-search-group-hide-on-query]:not([data-search-group])'
      );
      for (const el of chrome) el.classList.toggle(HIDDEN, searching);

      for (const el of scope.querySelectorAll('[data-search-empty]')) {
        el.classList.toggle(HIDDEN, !searching || hits > 0);
      }

      for (const link of scope.querySelectorAll('[data-search-all]')) {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('q', query.trim());
        link.href = url.toString();
      }

      if (status) {
        status.textContent = searching ? template.replace('[count]', String(hits)) : '';
      }
    }

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => apply(input.value), 120);
    });

    input.addEventListener('search', () => apply(input.value));

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') event.preventDefault();
      if (event.key !== 'Escape' || input.value === '') return;
      input.value = '';
      apply('');
    });

    document.addEventListener('shopify:section:load', () => {
      index = buildIndex(scope);
      apply(input.value);
    });

    const seeded = new URLSearchParams(window.location.search).get('q');
    if (seeded && input.value === '') input.value = seeded;

    if (input.value !== '') apply(input.value);
  }

  function init() {
    for (const host of document.querySelectorAll('document-search')) bind(host);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
